import { setQueriesDataFromKey } from '@pba/react-query';
import type { ChatroomDataObject } from '#models/services';
import { useQueryClient } from '#react-query';
import type { ChatroomsQueryData } from '../use-get-chatroom';
import { getChatroomDetailQueryKey } from '../use-get-chatroom/keys';
import { type ChatroomsInfiniteQueryData, getChatroomsInfiniteQueryKey } from '../use-get-chatrooms';

export const useAddChatroomToCache = () => {
  const queryClient = useQueryClient();

  return ({ newChatroom }: { newChatroom: ChatroomDataObject }) => {
    setQueriesDataFromKey<ChatroomsQueryData>(
      queryClient,
      getChatroomDetailQueryKey({ id: newChatroom._id }),
      newChatroom,
    );

    setQueriesDataFromKey<ChatroomsInfiniteQueryData>(queryClient, getChatroomsInfiniteQueryKey({}), (data) => {
      if (!data) {
        return {
          pageParams: [],
          pages: [[newChatroom]],
        };
      }

      const updatedPages = data.pages.map((page) => {
        const chatroomIndex = page.findIndex((chatroom) => chatroom?._id === newChatroom._id);
        if (chatroomIndex !== -1) {
          const updatedPage = [...page];
          updatedPage[chatroomIndex] = null;
          return updatedPage;
        }

        return page;
      });

      const firstPage = updatedPages[0] ?? [];
      const newFirstPage = [newChatroom, ...firstPage];

      return {
        pageParams: data.pageParams,
        pages: [newFirstPage, ...updatedPages.slice(1)],
      };
    });
  };
};
